var _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

import { styled } from '@creditas-ui/system';
import { Box } from './Box';
var Flex = styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose([""])));
Flex.defaultProps = {
  display: 'flex'
};
export { Flex };